import { styled } from 'linaria/react';
import { FunctionalComponent, h, Fragment } from 'preact';

import { Header } from 'features/verify/ui/header';
import { Footer } from 'ui/footer';
import { Container } from 'ui/container';
import { Title } from 'ui/typography';
import { version } from '../../../../package.json';

export type ErrorLayoutProps = {
	title: string;
	description: string | any;
}

export const ErrorLayout: FunctionalComponent<ErrorLayoutProps> = (props) => {
	const { title, description, children } = props;

	return (
		<Fragment>
			<Header/>
			<Container style={{paddingBottom: 10}}>
				<Title
					style={{
						textAlign: 'center',
					}}
				>
					{title}
				</Title>
				<IconContainer>
					<img src={`https://cdn.hive.id/verify-js/${version}/images/warning.svg`} alt=""/>
				</IconContainer>
				<Text>{description}</Text>
				<Content>{children}</Content>
			</Container>
			<Footer/>
		</Fragment>
	);
};

const IconContainer = styled('div')`
	margin: 32px auto;
`;
const Text = styled('p')`
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
	color: #262626;
`;
const Content = styled('div')`
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
`;
